// removed by extract-text-webpack-plugin
module.exports = {"cr_component":"_1jLcm6oZsOtJ_049M2Wkg8","comImg":"_1kjvPhbVengebAwDxLwglV","headerTop":"sDyEZvA_rysZg7CF9efr7","headerBack":"_2IqXpjHhIFFen8_46QrB7x","headerLogoTop":"wzo7gQAomtUeST13GIk-o","headerGymsTop":"_3qDRjpE5zjEKbvOYrj7A1U","content":"_3vp18tIAn5crvaDK_Of7uI","contentLeft":"_3I5EPAkLZ-fAJ8IS4Z3WMv","contentLeftMenuBlack":"_1IDET-SgOxVvHa7yzMREtr","contentLeftMenuBackground":"_1J-saoZ_HY_jXKxajt0WB8","icon_di_a":"_3mx8KuA7DtJDMbCy5gcrRM","contentRight":"otLGu1olJ30QaqjNICith","contentRightBlack":"_24WkN8-72QJxOn1fmLsS4u","contentRightHome":"_3-42g_6AcpxRCZba6aD_pq","contentBottom":"_8dAmcJisEWUSfmf2zIj8z"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WorkstationList/WorkstationList.scss
 ** module id = 1103
 ** module chunks = 0
 **/